module.exports = __webpack_public_path__ + "static/earthToYou_small-ec3979dc55f84aa82bf63d6c5b28452c.png";